export default __webpack_public_path__ + "static/media/empty-locale.da51ac88.png";